import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import AddWalletAccCharge from "./AddWalletAccCharge";
import AddSubWallet from "./AddSubWallet";
import SuspendWalletAcc from "./SuspendWalletAcc";
import Deposit from "./Deposit";
import RejectSavingsAcc from "./RejectSavingsAcc";
import Withdraw from "./Withdraw";
import ApproveWalletAcc from "./ApproveWalletAcc";
import ActivateWalletAcc from "./ActivateWalletAcc";
import Transfer from "./Transfer";

const WalletAccountMainActionPage = (props) => {
  const { userData } = props;
  const { state } = useLocation();

  useEffect(() => {
    // console.log(state);
  }, []);

  const renderActions = () => {
    switch (state?.actionLabel?.toLowerCase()) {
      case "cash in":
        return <Deposit userData={userData} />;
      case "cash out":
        return <Withdraw userData={userData} />;
      case "transfer to sub wallet":
        return <Transfer userData={userData} />;
      case "reject":
        return <RejectSavingsAcc userData={userData} />;
      case "add sub wallet":
        return <AddSubWallet userData={userData} />;
      case "apply charge":
        return <AddWalletAccCharge userData={userData} />;
      case "approve":
        return <ApproveWalletAcc userData={userData} />;
      case "activate":
        return <ActivateWalletAcc userData={userData} />;

      case "close":
        return <SuspendWalletAcc userData={userData} />;
      default:
        return <>No {state.actionLabel} Component found contact dev</>;
    }
  };
  return <>{renderActions()}</>;
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(WalletAccountMainActionPage);
